export type MasonryType = MasonryTypeName.ConcreteBlock | MasonryTypeName.BrickBlock;

export enum MasonryTypeName {
  ConcreteBlock = 'concreteBlock',
  BrickBlock = 'brickBlock'
}
